import React, { useState } from 'react'
import "./Nevbar.css";
import Data from "../Data/Data"
import { HiBars3, HiXMark } from "react-icons/hi2";

const Nevbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className='ps-nav'>
      <div className="ps-nav-bar">
        <div className="ps-nav-logo">
          <img src={Data.logo} alt="" />
        </div>

        <div className="ps-nav-links">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#ser">Services</a>
          <a href="#why">Why Us</a>
          <a href="#pro">Process</a>
          <a href="#cont">Contact</a>
        </div>

        <div className="ps-nav-right">
          <div className="ps-nav-cta">
            <a href="#cont">Talk to an advisor</a>
          </div>
          <button
            className="ps-nav-toggle"
            aria-expanded={open}
            aria-controls="psNavDrawer"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen(true)}
          >
            <HiBars3 />
          </button>
        </div>
      </div>

      <div
        className={`ps-nav-overlay ${open ? "ps-is-open" : ""}`}
        onClick={() => setOpen(false)}
      />

      <div
        className={`ps-nav-drawer ${open ? "ps-is-open" : ""}`}
        id="psNavDrawer"
        aria-hidden={!open}
      >
        <div className="ps-nav-drawer-top">
          <div className="ps-nav-logo">
            <img src={Data.logo} alt="" />
          </div>
          <button
            className="ps-nav-drawer-close"
            aria-label="Close menu"
            onClick={() => setOpen(false)}
          >
            <HiXMark />
          </button>
        </div>

        <nav className="ps-nav-drawer-links">
          <a href="#home" onClick={() => setOpen(false)}>Home</a>
          <a href="#about" onClick={() => setOpen(false)}>About</a>
          <a href="#ser" onClick={() => setOpen(false)}>Services</a>
          <a href="#why" onClick={() => setOpen(false)}>Why Us</a>
          <a href="#pro" onClick={() => setOpen(false)}>Process</a>
          <a href="#cont" onClick={() => setOpen(false)}>Contact</a>
        </nav>

        <div className="ps-nav-cta ps-nav-drawer-cta">
          <a href="">Talk to an advisor</a>
        </div>
      </div>
    </div>
  )
}

export default Nevbar